/*! Kundenvorschau-Schnappschuss — VIVIANNA, 2026-08-12
 *
 * Zweck: Beim Bestellen genau das Bild festhalten, das die Kundin auf dem
 * Bildschirm sieht, damit die Werkstatt es in der Gravur-Karte sieht.
 *
 * ★★ OBERSTE REGEL: Der Kauf darf davon NIE langsamer oder unsicherer werden.
 * Deshalb ist der Ablauf zweigeteilt:
 *
 *   1) WÄHREND des Warenkorb-Wegs (vormerken):  nur Zufalls-ID + cloneNode.
 *      cloneNode haengt nichts ins Dokument → kein Layout, kein Rendern,
 *      kein Netzverkehr. Kosten: Bruchteile einer Millisekunde.
 *   2) NACH dem Warenkorb (senden, ausgeloest von 'variant:add'):
 *      Klone kurz unsichtbar einhaengen → html2canvas → JPEG → Upload.
 *      Laeuft im Hintergrund; wenn irgendetwas schiefgeht, passiert nichts
 *      weiter: die Bestellung ist laengst abgeschickt, die Karte faellt auf
 *      den bisherigen Weg zurueck.
 *
 * In der Bestellung steht nur eine kurze ID (z. B. _k530_vorschau: aB3…),
 * die Bilder liegen unter tools…/vorschau/<id>-<seite>.jpg.
 */
(function () {
  'use strict';

  var ZIEL = 'https://tools.weiannakunming.com/upload/vorschau';
  var MAX_SEITEN = 10;         // K530 kann 4 Plättchen × 2 Seiten = 8 haben
  var MAX_KB = 700;            // Serverseitiges Limit ist 800 KB
  var BUEHNE_PX = 300;         // Breite der unsichtbaren Buehne = Breite der Kachel
  var SKALA = 1.6;             // 300 × 1.6 ≈ 480 px Ausgabe (Karte zeigt ~250)

  // Ein Auftrag pro Kachel: {node: geklonter Knoten, seite: 'grossfront'}
  var warteschlange = [];      // vorgemerkte Auftraege (FIFO, wartet auf variant:add)
  var gesendet = {};           // vid → true, damit nichts doppelt hochgeht
  var letzteKennung = '';      // Fingerabdruck der letzten Eigenschaften
  var letzteVid = '';          // zugehoerige vid (fuer Doppelklick, s. u.)
  var laeuft = false;          // es rendert gerade ein Auftrag

  function zufallsId() {
    try {
      var a = new Uint8Array(12);
      (window.crypto || window.msCrypto).getRandomValues(a);
      var s = '';
      for (var i = 0; i < a.length; i++) s += ('0' + a[i].toString(16)).slice(-2);
      return s;                                    // 24 Hex-Zeichen
    } catch (e) {
      return String(Date.now()) + Math.random().toString(36).slice(2, 10);
    }
  }

  /* ---- Schritt 1: vormerken (laeuft im Warenkorb-Weg, muss winzig sein) ----
   * konf = {
   *   praefix:  'k530',                       // fuer den Eigenschaftsnamen
   *   wurzel:   '.k530-root',                 // Container, dessen CSS gilt
   *   kacheln:  function(){ return [ {el: DOM, seite: 'grossfront'}, … ] }
   * }
   * Rueckgabe: die vid (oder '' wenn nichts zu sichern war).
   */
  function vormerken(konf, properties_arr) {
    if (!konf || typeof konf.kacheln !== 'function') return '';
    var liste;
    try { liste = konf.kacheln() || []; } catch (e) { return ''; }
    if (!liste.length) return '';
    var jobs = [];
    for (var i = 0; i < liste.length && jobs.length < MAX_SEITEN; i++) {
      var k = liste[i];
      if (!k || !k.el || !k.el.cloneNode) continue;
      var seite = String(k.seite || '').toLowerCase().replace(/[^a-z0-9]/g, '');
      if (!seite) continue;
      // ★★ Die echte Kachelbreite MUSS mit: die Gravurgroesse ist in absoluten
      // Pixeln gerendert (Skalierung = tatsaechliche Breite / Referenzbreite).
      // Auf einer fest 300 px breiten Buehne waechst das Hintergrundbild mit
      // (Prozentwerte), die Schrift aber nicht → die Gravur saehe 20–50 %
      // ZU KLEIN aus. Danach graviert die Werkstatt zu klein und die Kundin
      // bekommt falsche Ware. Also hier die Breite mitnehmen und beim Rendern
      // exakt wieder herstellen.
      // (Gelesen wird, solange das Popup noch sichtbar ist — das Layout ist
      //  frisch, die Abfrage kostet keinen erzwungenen Reflow.)
      var breite = 0;
      try { breite = Math.round(k.el.getBoundingClientRect().width) || 0; } catch (e) {}
      // ★★ Zugeklappte/unsichtbare Kacheln NICHT mitnehmen (Breite ~0).
      // Grund: die Gravurgroesse wird gegen die *tatsaechliche* Breite
      // gerechnet; ist die Kachel eingeklappt (display:none), rechnet der
      // Konfigurator mit der Referenzbreite weiter, im iframe bekommt die
      // Kachel aber ihre echte Breite → das Bild zeigt ein falsches
      // Groessenverhaeltnis. Ein falsches Bild ist schlimmer als keins.
      if (breite < 20) continue;
      // cloneNode(true) = reine Speicheroperation, kein Layout.
      // quelle = das Original; wird spaeter (nach dem Warenkorb) gebraucht, um
      // &lt;canvas&gt;-Inhalte nachzureichen — die kopiert cloneNode naemlich NICHT.
      // Hier bewusst nur die Referenz merken: das Umwandeln in ein Bild
      // (toDataURL) kostet Millisekunden und hat auf dem Kaufweg nichts zu suchen.
      jobs.push({ node: k.el.cloneNode(true), quelle: k.el,
                  seite: seite.slice(0, 16), breite: breite });
    }
    if (!jobs.length) return '';
    // ★ Gleiche Konfiguration → gleiche vid.
    // Sonst waere die Eigenschaft bei jedem Klick anders und Shopify koennte
    // zwei identische Positionen nicht mehr zu "Menge 2" zusammenfassen —
    // ein Doppelklick saehe im Warenkorb aus wie zwei verschiedene Artikel.
    var kennung = '';
    try { kennung = JSON.stringify(properties_arr || []); } catch (e) { kennung = ''; }
    var vid;
    if (kennung && kennung === letzteKennung && letzteVid) {
      vid = letzteVid;                 // derselbe Kauf noch einmal → alles gleich
    } else {
      vid = zufallsId();
      letzteKennung = kennung;
      letzteVid = vid;
    }
    warteschlange.push({ vid: vid, wurzel: konf.wurzel || '', jobs: jobs,
                         cssFilter: konf.cssFilter || '' });
    if (warteschlange.length > 4) warteschlange.shift();   // nicht unbegrenzt sammeln
    if (properties_arr && properties_arr.push) {
      // "_snap" statt "_vorschau" (2026-08-15): Billbee matcht Regeln per
      // Teilstring, und "vorschau" kollidierte mit der Kundenoption
      // "Vorschau" (Kundin will Vorschau-Mail) → falsche Warteschlange.
      // Serverseite (retoure.py) akzeptiert _snap UND alt _vorschau.
      properties_arr.push(['_' + (konf.praefix || 'x') + '_snap', vid]);
    }
    return vid;
  }

  // Wenn der Kauf doch nicht zustande kommt (Pflichtfeld fehlt o. Ae.), darf
  // nichts liegen bleiben — sonst wird es beim naechsten beliebigen Warenkorb-
  // Ereignis hochgeladen, ohne zu einer Bestellung zu gehoeren.
  function verwerfen() { warteschlange.length = 0; }

  /* ---- Schritt 2: senden (nach dem Warenkorb, Hintergrund) ----
   * html2canvas wird NUR im iframe geladen (siehe h2cImRahmen) — die
   * Produktseite selbst bekommt die 198 KB nie zu sehen.
   */

  /* ★★ Rendern in einem eigenen, leeren iframe — NICHT in der Produktseite.
   *
   * Gemessen auf der echten Seite: html2canvas klont IMMER das ganze Dokument
   * und rechnet fuer jeden Knoten die Stile aus. Auf der Produktseite (3476
   * Knoten, 68 Stylesheets, 2193 Regeln) blockiert das den Hauptthread rund
   * 2,5 Sekunden — sogar fuer ein leeres <div>. Genau in dem Moment will die
   * Kundin aber weiterklicken. Im leeren iframe (13 Knoten, 168 Regeln) sind
   * es 150 ms, also unbemerkbar. Deshalb: eigenes iframe, nur das noetige CSS.
   */
  function rahmenBauen(wurzelKlasse, cssFilter, breiteste) {
    // Rahmen so breit wie die breiteste Kachel (K530 ist 190–240 px schmal,
    // A181/A189/K542 sind 500 px breit). Zu schmal ginge zwar auch — gemessen
    // wird trotzdem vollstaendig gerendert —, aber mit passender Breite bleibt
    // das Layout natuerlich und es gibt keine negativen Offsets.
    var px = Math.max(BUEHNE_PX, Math.min(1200, (breiteste || 0) + 40));
    var ifr = document.createElement('iframe');
    ifr.id = 'vorschau-rahmen';
    ifr.setAttribute('aria-hidden', 'true');
    ifr.style.cssText = 'position:fixed;left:-99999px;top:0;width:' +
      px + 'px;height:' + px + 'px;border:0;opacity:0;' +
      'pointer-events:none;z-index:-1';
    document.body.appendChild(ifr);
    var d = ifr.contentDocument;
    d.open();
    d.write('<!doctype html><html><head><meta charset="utf-8"></head>' +
            '<body style="margin:0"></body></html>');
    d.close();
    // Nur die <style>-Bloecke des eigenen Konfigurators uebernehmen
    // (erkannt an der SKU-Klasse) — inklusive @font-face fuer die Gravurschrift.
    var css = '';
    var marke = cssFilter || ('.' + String(wurzelKlasse || '').split(' ')[0]);
    Array.prototype.forEach.call(document.querySelectorAll('style'), function (s) {
      var t = s.textContent || '';
      if (t.indexOf(marke) !== -1 || t.indexOf('@font-face') !== -1) css += t + '\n';
    });
    var st = d.createElement('style');
    st.textContent = css;
    d.head.appendChild(st);
    var innen = d.body;
    String(wurzelKlasse || '').split(' ').forEach(function (teil) {
      teil = teil.replace(/^\./, '').trim();
      if (!teil) return;
      var el = d.createElement('div');
      el.className = teil;
      innen.appendChild(el);
      innen = el;
    });
    return { rahmen: ifr, dok: d, innen: innen };
  }

  /* &lt;canvas&gt;-Inhalte in die Kopie uebertragen (cloneNode kopiert nur das
   * leere Element). Laeuft NACH dem Warenkorb, darf also etwas kosten.
   * PNG, weil manche Zeichnungen (z. B. Sternenhimmel) transparent sind. */
  function canvasNachreichen(quelle, kopie, dok) {
    if (!quelle || !kopie || !quelle.querySelectorAll) return;
    var q = quelle.querySelectorAll('canvas');
    var z = kopie.querySelectorAll('canvas');
    for (var i = 0; i < q.length && i < z.length; i++) {
      try {
        var alt = q[i], neu = z[i];
        if (!neu.parentNode || !alt.width || !alt.height) continue;
        var bild = dok.createElement('img');
        bild.style.cssText = 'display:block;width:' +
          (alt.style.width || (alt.width + 'px')) + ';height:' +
          (alt.style.height || (alt.height + 'px'));
        var vorlage = alt;
        if (alt.width > 900) {                 // riesige Zeichnungen verkleinern
          var klein = document.createElement('canvas');
          klein.width = 900;
          klein.height = Math.max(1, Math.round(alt.height * 900 / alt.width));
          klein.getContext('2d').drawImage(alt, 0, 0, klein.width, klein.height);
          vorlage = klein;
        }
        bild.src = vorlage.toDataURL('image/png');
        neu.parentNode.replaceChild(bild, neu);
      } catch (e) { /* getaintetes canvas o. Ae. → diese Kachel ohne Zeichnung */ }
    }
  }

  function h2cImRahmen(dok, fertig) {
    if (dok.defaultView.html2canvas) return fertig(true);
    var s = dok.createElement('script');
    s.src = window.VORSCHAU_H2C_URL || '';
    if (!s.src) return fertig(false);
    s.onload = function () { fertig(!!dok.defaultView.html2canvas); };
    s.onerror = function () { fertig(false); };
    dok.head.appendChild(s);
  }

  function senden() {
    if (laeuft) return;                 // immer nur ein Auftrag gleichzeitig
    var auftrag = warteschlange.shift();
    if (!auftrag) return;
    if (gesendet[auftrag.vid]) return senden();   // schon hochgeladen → naechster
    gesendet[auftrag.vid] = true;
    laeuft = true;
    var breiteste = 0;
    auftrag.jobs.forEach(function (j) {
      if (j.breite > breiteste) breiteste = j.breite;
    });
    var buehne;
    try { buehne = rahmenBauen(auftrag.wurzel, auftrag.cssFilter, breiteste); }
    catch (e) { laeuft = false; return; }
    // Notbremse: was auch immer schiefgeht, nach 60 s ist der Rahmen weg.
    var notaus = setTimeout(function () {
      try { buehne.rahmen.remove(); } catch (e) {}
      laeuft = false;
    }, 60000);
    h2cImRahmen(buehne.dok, function (ok) {
      if (!ok) {
        clearTimeout(notaus);
        try { buehne.rahmen.remove(); } catch (e) {}
        laeuft = false;
        return;
      }
      var h2c = buehne.dok.defaultView.html2canvas;
      auftrag.jobs.forEach(function (job) {
        try {
          var kopie = buehne.dok.importNode(job.node, true);
          // Breite exakt wie im Popup. Normalerweise bringt die geklonte Zelle
          // ihre inline max-width selbst mit; ist die Kachel zugeklappt
          // (Breite 0) bleibt sie unangetastet — dort wurde die Gravur ohnehin
          // gegen die Referenzbreite gerendert.
          if (job.breite) {
            kopie.style.width = job.breite + 'px';
            kopie.style.maxWidth = job.breite + 'px';
            kopie.style.flex = '0 0 auto';
          }
          // Geklonte id-Attribute wuerden im iframe Duplikate erzeugen
          var mitId = kopie.querySelectorAll ? kopie.querySelectorAll('[id]') : [];
          for (var q = 0; q < mitId.length; q++) mitId[q].removeAttribute('id');
          if (kopie.removeAttribute) kopie.removeAttribute('id');
          canvasNachreichen(job.quelle, kopie, buehne.dok);
          buehne.innen.appendChild(kopie);
        } catch (e) {}
      });
      // Die eingehaengten Kopien in derselben Reihenfolge wie die Jobs.
      var kacheln = buehne.innen.children;
      // ★ STRENG NACHEINANDER, mit Pause dazwischen: 8 Kacheln gleichzeitig
      // waeren auch im iframe eine unnoetige Last auf dem Geraet der Kundin.
      var i = 0;
      function abschliessen() {
        clearTimeout(notaus);
        try { buehne.rahmen.remove(); } catch (e) {}
        laeuft = false;
        if (warteschlange.length) setTimeout(senden, 1500);   // naechster Auftrag
      }
      function naechste() {
        if (i >= auftrag.jobs.length || i >= kacheln.length) return abschliessen();
        var job = auftrag.jobs[i];
        var ziel = kacheln[i];
        i++;
        var weiter = function () { setTimeout(naechste, 250); };  // Luft lassen
        try {
          h2c(ziel, {
            useCORS: true, backgroundColor: '#ffffff', logging: false,
            scale: SKALA
          }).then(function (canvas) {
            canvas.toBlob(function (blob) {
              if (!blob || blob.size > MAX_KB * 1024) return weiter();
              try {
                var xhr = new XMLHttpRequest();
                xhr.open('POST', ZIEL + '?vid=' + encodeURIComponent(auftrag.vid) +
                         '&seite=' + encodeURIComponent(job.seite), true);
                xhr.timeout = 20000;          // haengender Server blockiert nichts
                xhr.onloadend = weiter;
                xhr.ontimeout = weiter;
                xhr.send(blob);
              } catch (e) { weiter(); }
            }, 'image/jpeg', 0.82);
          }).catch(function () { weiter(); });
        } catch (e) { weiter(); }
      }
      // Erst starten, wenn der Browser gerade nichts Wichtigeres tut.
      if (window.requestIdleCallback) {
        requestIdleCallback(naechste, { timeout: 3000 });
      } else {
        setTimeout(naechste, 500);
      }
    });
  }

  // 'variant:add' feuert das Theme nach erfolgreichem cart/add.js.
  // Zusaetzlich ein Sicherheitsnetz, falls das Event einmal ausbleibt.
  // 'variant:add' feuert das Theme nach erfolgreichem cart/add.js.
  // ★ Bewusst spaet und nur im Leerlauf: das einmalige Parsen von
  // html2canvas (198 KB) belegt den Hauptthread ~1 s (gemessen). Direkt nach
  // dem Klick will die Kundin den Warenkorb sehen — diese Sekunde gehoert ihr.
  // Also: 2,5 s warten, dann auf den ersten Leerlauf warten (max. 10 s),
  // und wenn der Tab im Hintergrund/verlassen ist, gar nicht erst anfangen.
  document.documentElement.addEventListener('variant:add', function () {
    setTimeout(function () {
      if (document.hidden) {             // Tab weg → spaeter, beim Zurueckkommen
        document.addEventListener('visibilitychange', function nochmal() {
          if (document.hidden) return;
          document.removeEventListener('visibilitychange', nochmal);
          setTimeout(starten, 1500);
        });
        return;
      }
      starten();
    }, 2500);
  });

  function starten() {
    if (window.requestIdleCallback) {
      requestIdleCallback(senden, { timeout: 10000 });
    } else {
      setTimeout(senden, 800);
    }
  }

  window.VorschauSchnappschuss = { vormerken: vormerken, senden: senden,
                                   verwerfen: verwerfen };
})();
